/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Device = z.enum(['TABLET', 'DESKTOP', 'MOBILE']);

export type Device = z.infer<typeof Device>;
